import { render, staticRenderFns } from "./MyPage3.vue?vue&type=template&id=7a8f2cee&scoped=true"
import script from "./MyPage3.vue?vue&type=script&lang=js"
export * from "./MyPage3.vue?vue&type=script&lang=js"
import style0 from "./MyPage3.vue?vue&type=style&index=0&id=7a8f2cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f2cee",
  null
  
)

export default component.exports